class AiUsageSummary {
    constructor(
        public requestCount: number = 0,
        public apiCallCount: number = 0,
        public webSearchCallCount: number = 0,
        public inputTokens: number = 0,
        public inputCachedTokens: number = 0,
        public outputTokens: number = 0,
        public totalTokens: number = 0,
        public executionTimeMs: number = 0,
        public price: number = 0
    ) {
        //
    }

    public static fromPOJO(data: any) {
        return new AiUsageSummary(
            data?.requestCount ?? 0,
            data?.apiCallCount ?? 0,
            data?.webSearchCallCount ?? 0,
            data?.inputTokens ?? 0,
            data?.inputCachedTokens ?? 0,
            data?.outputTokens ?? 0,
            data?.totalTokens ?? 0,
            data?.executionTimeMs ?? 0,
            Number(data?.price ?? 0)
        );
    }
}

export default AiUsageSummary;
